export const RewwardIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.4166 10.5416V13.625C15.4166 16.225 12.9916 18.3333 9.99998 18.3333C7.00831 18.3333 4.58331 16.225 4.58331 13.625V10.5416C4.58331 13.1416 7.00831 15 9.99998 15C12.9916 15 15.4166 13.1416 15.4166 10.5416Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4166 6.37496C15.4166 7.13329 15.2083 7.83329 14.8416 8.43329C13.95 9.89996 12.1166 10.8333 9.99998 10.8333C7.88331 10.8333 6.04998 9.89996 5.15832 8.43329C4.79165 7.83329 4.58331 7.13329 4.58331 6.37496C4.58331 5.07496 5.19164 3.89996 6.16664 3.04996C7.14997 2.19163 8.49998 1.66663 9.99998 1.66663C11.5 1.66663 12.85 2.19163 13.8333 3.04163C14.8083 3.89996 15.4166 5.07496 15.4166 6.37496Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4166 6.37496V10.5416C15.4166 13.1416 12.9916 15 9.99998 15C7.00831 15 4.58331 13.1416 4.58331 10.5416V6.37496C4.58331 3.77496 7.00831 1.66663 9.99998 1.66663C11.5 1.66663 12.85 2.19163 13.8333 3.04163C14.8083 3.89996 15.4166 5.07496 15.4166 6.37496Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
